import React, { useEffect } from 'react';

declare global {
    interface Window {
        adsbygoogle: any[];
    }
}

/**
 * Google AdSense Vertical Ad Unit
 * 
 * Strict implementation of user-provided ad code.
 * Dimensions: Responsive (typically 160x600 equivalent or flexible)
 */
const GoogleAdUnit: React.FC = () => {
    useEffect(() => {
        try {
            (window.adsbygoogle = window.adsbygoogle || []).push({});
        } catch (e) {
            console.error('AdSense push error:', e);
        }
    }, []);

    return (
        <div className="w-full my-4 flex justify-center">
            {/* Google AdSense Unit */}
            <ins
                className="adsbygoogle"
                style={{ display: 'block' }}
                data-ad-client="ca-pub-7144055620381408"
                data-ad-slot="1688628369"
                data-ad-format="auto"
                data-full-width-responsive="true"
            />
        </div>
    );
};

export default GoogleAdUnit;
